module.exports = __webpack_public_path__ + "img/tool3.30ed457c.png";